import { createSlice } from "@reduxjs/toolkit";
import {
  OrganizationCaseDetailsAction,
  allAgreementDocumentDeleteAction,
  allAgreementDocumentListAction,
  allCaseDetailsAction,
  allCaseTypeAction,
  caseBulkFilterAction,
  caseDetailsHistoryAction,
  caseTrackingUpdateAction,
  dashboardCaseDetailsCountsAction,
  filterColumnAction,
  pdfIDMatchingAction,
  preTrailCaseDetailsDocumentsAction,
  preTrailCaseDetailsCreateAction,
  singleCaseDetailsAction,
  updateAppointmentOfArbitratorSec11and12Action,
  updateArbitrationClausAndAgreementAction,
  updateArbitrationDurationAndTimelineManagementAction,
  updateArbitrationEnforcementAndAppealsAction,
  updateArbitrationFeePaymentStatusAction,
  updateArbitrationHoldWithdrawalAndSettlementAction,
  updateArbitrationInterimOrdersReliefsAwardsAction,
  updateArbitrationNoticesKeyDatesAction,
  updateArbitrationWitnessEvidenceAndExpertReportAction,
  updateCaseDetailsAction,
  updateCasePrimaryInformationAction,
  updateFinalAwardAction,
  updateInitiationOfArbitrationAction,
  updateInterimOrdersAction,
  updateSec17InterimOrdersAction,
  updateSec9InterimOrdersAction,
  preTrailCaseDetailsUpdateAction,
  preTrailCaseDetailsDeleteAction,
  claimantsListOfEvidenceCreateAction,
  claimantsListOfEvidenceDeleteAction,
  claimantsListOfEvidenceUpdateAction,
  respondentsListOfEvidenceCreateAction,
  respondentsListOfEvidenceDeleteAction,
  respondentsListOfEvidenceUpdateAction,
  claimantSideWitnessCreateAction,
  claimantSideWitnessUpdateAction,
  claimantSideWitnessDeleteAction,
  respondentWitnessCreateAction,
  respondentWitnessUpdateAction,
  respondentWitnessDeleteAction,
  claimantSideArgumentsCreateAction,
  claimantSideArgumentsUpdateAction,
  claimantSideArgumentsDeleteAction,
  respondentSideArgumentsCreateAction,
  respondentSideArgumentsUpdateAction,
  respondentSideArgumentsDeleteAction,
  dispositionsCreateAction,
  dispositionsUpdateAction,
  dispositionsDeleteAction,
  enforcementsCreateAction,
  enforcementsUpdateAction,
  enforcementsDeleteAction,
  appealDeleteAction,
  userFilterColumnAction,
  caseDetailsBulkUpdateAction,
  createClaimantCounselAction,
  updateClaimantCounselAction,
  deleteClaimantCounselAction,
  quickViewDetailsAction,
  sec17InterimOrdersRevokeOrderDocumentListAction,
  caseDetailsTemplateBulkUpdateAction,
  getOrganizationBatchNoAction,
} from "../../actions/Case/caseAction";
import {
  allCaseMappingDetailAction,
  caseMappingDetailAction,
  caseMappingDetailIsActiveAction,
  caseMappingDetailUpdateAction,
  caseMappingUploadAction,
  organizationActiveCaseTemplateAction,
  selectedCaseMappingDetailAction,
} from "../../actions/Case/caseMappingAction";
import { animateCss } from "../../../pages/TosterAlert";
import { caseDetailsFindCaseIDAction } from "../../actions/Checklist/checklistAction";
import { createSplitChecklistDocumentAction } from "../../actions/checklistDocuments/checklistDocumentsAction";
import {
  UpdateCaseFilterAction,
  userUpdateCaseFilterAction,
} from "../../actions/UserAction/usersAction";
import { exportPDFDocumentAction } from "../../actions/hooks/exportDocumentAction";
import { allOrganiationReportsAction, allOrganiationSingleReportsAction } from "../../actions/OrganizationAction/organizationReportsAction";


const caseInitialState = {
  loadingProgress: false,
  progress: 0,
  error: null,
  pagination: {
    pageIndex: 0,
    pageSize: 10,
  },
  settings: [],
  history: [],
  quickView: [],
  editCaseDetails: null,
  bulkUpdate: [],
  caseMappingDetails: {
    allCaseMappingDetails: [],
    mappingDetail: [],
    mappingTemplate: [],
  },
  caseDetails: {
    allData: [],
    pageCount: null,
    caseTemplate: [],
  },
  preTrailCaseDetailsDocuments: [],
  caseFilter: null,
  columnArrange: null,
  allotment: {
    allotmentHeader: [],
    allotmentOrganization: [],
    allotmentOrganizationTemplate: [],
  },
  reports: [],
  exportReport: [],
  selectedReport: [],
  loading: false,
  data: null,
  createCase: {
    loading: false,
    error: "",
  },
  agreementDocumentList: null,
  revocationDocumentList: null,
  notMatchingID: [],
  matchedAgreements: null,
  caseTableFilters: {
    organization: null,
    caseType: null,
    columnFilters: [],
    globalFilter: "",
    sorting: [],
    activeCaseStatus: "ALL",
    advAgreements: "",
    isAdvancedFilterActive: false,
  },
};

const filter = {};

const caseSlice = createSlice({
  name: "case",
  initialState: caseInitialState,
  reducers: {
    resetMappingDetailsReducer: (state, action) => {
      state.caseMappingDetails.mappingDetail = [];
      state.caseMappingDetails.mappingTemplate = [];
      return state;
    },
    resetMappingAllDetailsReducer: (state, action) => {
      state.caseMappingDetails = {
        allCaseMappingDetails: [],
        mappingDetail: [],
        mappingTemplate: [],
      };

      return state;
    },
    allotmentHeaderReducer: (state, action) => {
      state.allotment.allotmentHeader = action.payload;
    },
    mappingTemplateReducer: (state, action) => {
      state.caseMappingDetails.mappingTemplate =
        action?.payload?.mappingData ?? action.payload;
      state.caseMappingDetails.mappingDetail = action?.payload?.mappingData
        ? action.payload
        : [];
      return state;
    },
    resetSingleCaseDetailsReducer: (state, action) => {
      state.editCaseDetails = null;
      return state;
    },

    bulkCaseUpdateReducer: (state, action) => {
      state.bulkUpdate = action.payload;
      return state;
    },
    resetOrgCaseTypeReportReducer: (state, action) => {
      state.exportReport = [];
      state.selectedReport = [];
      return state;
    },
    setPaginationReducer: (state, action) => {
      return {
        ...state,
        pagination: action.payload,
      };
    },
    resetPaginationReducer: (state) => {
      return {
        ...state,

        pagination: {
          ...state.pagination,
          pageIndex: 0
        }
      };

    },
    setPaginationSize: (state, action) => {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          pageIndex: 0,
          pageSize: action.payload
        }
      };
    },
    setProgress: (state, action) => {
      state.progress = action.payload;
    },
    setCaseTableFiltersReducer: (state, action) => {
      state.caseTableFilters = {
        ...state.caseTableFilters,
        ...action.payload,
      };
      return state;
    },
    resetCaseTableFiltersReducer: (state) => {
      state.caseTableFilters = {
        organization: null,
        caseType: null,
        columnFilters: [],
        globalFilter: "",
        sorting: [],
        activeCaseStatus: "ALL",
        advAgreements: "",
        isAdvancedFilterActive: false,
      };
      return state;
    },

  },
  extraReducers: (builder) =>
    builder
      .addCase(allCaseTypeAction.pending, (state, action) => {
        // state.loading = true;
        return state;
      })
      .addCase(allCaseTypeAction.fulfilled, (state, action) => {
        state.settings = action.payload?.data?.[0];
        state.loading = false;
      })
      .addCase(allCaseTypeAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(allCaseMappingDetailAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(allCaseMappingDetailAction.fulfilled, (state, action) => {
        state.loading = false;
        state.caseMappingDetails.allCaseMappingDetails = action.payload;
      })
      .addCase(allCaseMappingDetailAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(selectedCaseMappingDetailAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(selectedCaseMappingDetailAction.fulfilled, (state, action) => {
        state.loading = false;
        state.caseMappingDetails.allCaseMappingDetails = action.payload;
        return state;
      })
      .addCase(selectedCaseMappingDetailAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(caseMappingUploadAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(caseMappingUploadAction.fulfilled, (state, action) => {
        state.loading = false;
        animateCss("success", "Case Template Created Successfully");
      })
      .addCase(caseMappingUploadAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(
        organizationActiveCaseTemplateAction.pending,
        (state, action) => {
          state.loading = true;
          return state;
        }
      )
      .addCase(
        organizationActiveCaseTemplateAction.fulfilled,
        (state, action) => {
          state.caseMappingDetails.allotmentOrganizationTemplate = [];
          if (action.payload) {
            state.allotment.allotmentOrganizationTemplate =
              action.payload?.template;
          }
          if (!action.payload) {
            state.allotment.allotmentOrganizationTemplate = [];
          }

          state.loading = false;
          return state;
        }
      )
      .addCase(
        organizationActiveCaseTemplateAction.rejected,
        (state, action) => {
          state.loading = false;
        }
      )

      .addCase(caseMappingDetailUpdateAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(caseMappingDetailUpdateAction.fulfilled, (state, action) => {
        if (action.payload.data) {
          animateCss("success", "Case Template Update Successfully");
          state.caseMappingDetails.mappingDetail = [];
          state.caseMappingDetails.mappingTemplate = [];
        }
        state.loading = false;
      })
      .addCase(caseMappingDetailUpdateAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(caseMappingDetailIsActiveAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(caseMappingDetailIsActiveAction.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(caseMappingDetailIsActiveAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // .addCase(OrganizationCaseDetailsAction.pending, (state, action) => {
      //   state.loading = true;
      //   return state;
      // })
      // .addCase(
      //   OrganizationCaseDetailsAction.fulfilled,
      //   (state, { payload }) => {
      //     state.caseDetails.allData = payload?.data;
      //     state.caseDetails.pageCount = payload?.pageCount;
      //     state.caseFilter = JSON.parse(payload?.filter) ?? filter;
      //     state.loading = false;
      //     return state;
      //   }
      // )
      // .addCase(OrganizationCaseDetailsAction.rejected, (state, action) => {
      //   state.loading = false;
      // })

      .addCase(allCaseDetailsAction.pending, (state, action) => {
        state.loading = true;
        state.caseDetails.matchedAgreements = null;
        return state;
      })
      .addCase(allCaseDetailsAction.fulfilled, (state, { payload }) => {

        return {
          ...state,
          loading: false,
          caseDetails: {
            ...state.caseDetails,
            allData: payload?.data,
            pageCount: payload?.totalRecords,
            metricsTotalCount: payload?.metricsTotalCount,
            statusCounts: payload?.statusCounts,
            closingReasonCounts: payload?.closingReasonCounts,
            matchedAgreements: payload?.matchedAgreements,
            allRecordCount: payload?.allRecordCount,
            firmUser: payload?.firmUser,
            systemAdmin: payload?.systemAdmin,
            userOrganization: payload?.userOrganization,
          },
          caseFilter: Object.entries(payload?.filter || {}).reduce(
            (acc, [key, value], index) => ({
              ...acc,
              [key]: value === true && index < 20,
            }),
            {}
          ),
        }
      }
      )
      .addCase(allCaseDetailsAction.rejected, (state) => ({
        ...state,
        loading: false,
      }))

      .addCase(singleCaseDetailsAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(singleCaseDetailsAction.fulfilled, (state, action) => {
        let value = action.payload;
        value.alterCaseDetails = value?.alterCaseDetails
          ? JSON.parse(value?.alterCaseDetails)
          : null;
        state.editCaseDetails = value;
        state.loading = false;
        return state;
      })
      .addCase(singleCaseDetailsAction.rejected, (state, action) => {
        state.loading = false;
      })


      .addCase(quickViewDetailsAction.pending, (state, action) => {
        // state.loading = true;
        return state;
      })
      .addCase(quickViewDetailsAction.fulfilled, (state, action) => {
        let value = action.payload;
        state.quickView = value;
        state.loading = false;
        return state;
      })
      .addCase(quickViewDetailsAction.rejected, (state, action) => {
        state.quickView = {};
        state.loading = false;
      })

      .addCase(updateCaseDetailsAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(updateCaseDetailsAction.fulfilled, (state, action) => {
        animateCss("success", "Case Detail Update Successfully");
        setTimeout(() => {
          allCaseDetailsAction();
        }, 1000);
        state.loading = false;
      })
      .addCase(updateCaseDetailsAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(caseDetailsHistoryAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(caseDetailsHistoryAction.fulfilled, (state, action) => {
        state.history = action.payload?.data;

        state.loading = false;
      })
      .addCase(caseDetailsHistoryAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(caseTrackingUpdateAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(caseTrackingUpdateAction.fulfilled, (state, action) => {
        if (action.payload?.data) {
          animateCss("success", "Case Tracking Update Successfully");
        }
        state.loading = false;
      })
      .addCase(caseTrackingUpdateAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(caseDetailsFindCaseIDAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(caseDetailsFindCaseIDAction.fulfilled, (state, action) => {
        state.loading = false;
        createSplitChecklistDocumentAction(action.meta.arg);
        return state;
      })
      .addCase(caseDetailsFindCaseIDAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(updateCasePrimaryInformationAction.pending, (state) => {
        state.loading = true;
        return state;
      })
      .addCase(updateCasePrimaryInformationAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(updateCasePrimaryInformationAction.rejected, (state) => {
        state.loading = false;
      })
      .addCase(updateInitiationOfArbitrationAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(updateInitiationOfArbitrationAction.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateInitiationOfArbitrationAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(
        updateAppointmentOfArbitratorSec11and12Action.pending,
        (state) => {
          state.loading = true;
          return state;
        }
      )

      .addCase(
        updateAppointmentOfArbitratorSec11and12Action.fulfilled,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(
        updateAppointmentOfArbitratorSec11and12Action.rejected,
        (state) => {
          state.loading = false;
        }
      )
      .addCase(
        updateArbitrationInterimOrdersReliefsAwardsAction.pending,
        (state) => {
          state.loading = true;
          return state;
        }
      )

      .addCase(
        updateArbitrationInterimOrdersReliefsAwardsAction.fulfilled,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(
        updateArbitrationInterimOrdersReliefsAwardsAction.rejected,
        (state) => {
          state.loading = false;
        }
      )
      .addCase(
        updateArbitrationWitnessEvidenceAndExpertReportAction.pending,
        (state) => {
          state.loading = true;
          return state;
        }
      )

      .addCase(
        updateArbitrationWitnessEvidenceAndExpertReportAction.fulfilled,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(
        updateArbitrationWitnessEvidenceAndExpertReportAction.rejected,
        (state) => {
          state.loading = false;
        }
      )
      .addCase(
        updateArbitrationHoldWithdrawalAndSettlementAction.pending,
        (state) => {
          state.loading = true;
          return state;
        }
      )

      .addCase(
        updateArbitrationHoldWithdrawalAndSettlementAction.fulfilled,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(
        updateArbitrationHoldWithdrawalAndSettlementAction.rejected,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(
        updateArbitrationEnforcementAndAppealsAction.pending,
        (state) => {
          state.loading = true;
          return state;
        }
      )

      .addCase(
        updateArbitrationEnforcementAndAppealsAction.fulfilled,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(
        updateArbitrationEnforcementAndAppealsAction.rejected,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(updateArbitrationFeePaymentStatusAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(updateArbitrationFeePaymentStatusAction.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateArbitrationFeePaymentStatusAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateArbitrationNoticesKeyDatesAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(updateArbitrationNoticesKeyDatesAction.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateArbitrationNoticesKeyDatesAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(
        updateArbitrationDurationAndTimelineManagementAction.pending,
        (state) => {
          state.loading = true;
          return state;
        }
      )

      .addCase(
        updateArbitrationDurationAndTimelineManagementAction.fulfilled,
        (state) => {
          state.loading = false;
        }
      )

      .addCase(
        updateArbitrationDurationAndTimelineManagementAction.rejected,
        (state) => {
          state.loading = false;
        }
      )
      .addCase(updateArbitrationClausAndAgreementAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(updateArbitrationClausAndAgreementAction.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateArbitrationClausAndAgreementAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateSec17InterimOrdersAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(updateSec17InterimOrdersAction.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateSec17InterimOrdersAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateSec9InterimOrdersAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(updateSec9InterimOrdersAction.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateSec9InterimOrdersAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateInterimOrdersAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(updateInterimOrdersAction.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateInterimOrdersAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(updateFinalAwardAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(updateFinalAwardAction.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateFinalAwardAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(sec17InterimOrdersRevokeOrderDocumentListAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(sec17InterimOrdersRevokeOrderDocumentListAction.fulfilled, (state, action) => {
        state.loading = false;
        state.revocationDocumentList = action.payload?.data;
        return state;
      })

      .addCase(sec17InterimOrdersRevokeOrderDocumentListAction.rejected, (state) => {
        state.loading = false;
      })


      .addCase(allAgreementDocumentListAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(allAgreementDocumentListAction.fulfilled, (state, action) => {
        state.loading = false;
        state.agreementDocumentList = action.payload?.data;
        return state;
      })

      .addCase(allAgreementDocumentListAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(allAgreementDocumentDeleteAction.pending, (state) => {
        state.loading = true;
        return state;
      })

      .addCase(allAgreementDocumentDeleteAction.fulfilled, (state) => {
        state.loading = false;
        return state;
      })

      .addCase(allAgreementDocumentDeleteAction.rejected, (state) => {
        state.loading = false;
      })

      .addCase(caseBulkFilterAction.pending, (state, action) => {
        state.loading = true;

        return state;
      })

      .addCase(caseBulkFilterAction.fulfilled, (state, action) => {
        state.loading = false;

        return state;
      })

      .addCase(caseBulkFilterAction.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(userUpdateCaseFilterAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(userUpdateCaseFilterAction.fulfilled, (state, action) => {
        // state.caseFilter = action.meta.arg?.columnVisibility;

        let trueCount = 0;
        const casefilter = Object.fromEntries(
          Object.entries(action.meta.arg?.columnVisibility).map(
            ([key, value]) => {
              if (value === true && trueCount < 22) {
                trueCount++;
                return [key, true];
              }
              return [key, false];
            }
          )
        );

        // action.meta.arg?.columnVisibility ?? {};

        const filterColumn =
          casefilter && typeof casefilter === "object"
            ? Object.fromEntries(
              Object.entries(casefilter).map(([key, value]) => {
                if (value === true && trueCount < 22) {
                  trueCount++;
                  return [key, true];
                }
                return [key, false];
              })
            )
            : {};
        // casefilter ?? {};

        // const extractTrueKeys = (casefilter) => {
        //   if (casefilter && typeof casefilter === "object") {
        //     return [
        //       "#",
        //       ...Object.keys(casefilter).filter(
        //         (key) => casefilter[key] === true
        //       ),
        //     ];
        //   }
        //   return [];
        // };

        state.caseFilter = filterColumn;

        // extractTrueKeys;

        state.columnArrange = Object.keys(casefilter);
        // extractTrueKeys(casefilter);
        return state;
      })
      .addCase(userUpdateCaseFilterAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(UpdateCaseFilterAction.pending, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(UpdateCaseFilterAction.fulfilled, (state, action) => {
        const filterData = action?.payload?.data?.[0]?.caseFilter;
        const caseFilter = filterData ? JSON.parse(filterData) : {};
        let trueCount = 0;

        // Ensure caseFilter is an object before processing
        const processedCaseFilter = Object.fromEntries(
          Object.entries(caseFilter).map(([key, value]) => {
            if (value === true && trueCount < 22) {
              trueCount++;
              return [key, true];
            }
            return [key, false];
          })
        );

        // Re-evaluate filtering logic to maintain consistent behavior
        trueCount = 0;
        const filterColumn = Object.fromEntries(
          Object.entries(processedCaseFilter).map(([key, value]) => {
            if (value === true && trueCount < 22) {
              trueCount++;
              return [key, true];
            }
            return [key, false];
          })
        );

        // Update state
        state.caseFilter = filterColumn;
        state.columnArrange = Object.keys(processedCaseFilter);
        return state;
      })
      .addCase(UpdateCaseFilterAction.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(userFilterColumnAction.pending, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(userFilterColumnAction.fulfilled, (state, action) => {
        const casefilter = action.payload ?? {};

        const extractTrueKeys = (casefilter) => {
          if (casefilter && typeof casefilter === "object") {
            return [
              "#",
              ...Object.keys(casefilter).filter(
                (key) => casefilter[key] === true
              ),
            ];
          }
          return [];
        };

        state.caseFilter = casefilter;

        state.columnArrange = Object.keys(casefilter);
        // extractTrueKeys(casefilter);
        return state;
      })
      .addCase(userFilterColumnAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(pdfIDMatchingAction.pending, (state, action) => {
        return state;
      })
      .addCase(pdfIDMatchingAction.fulfilled, (state, action) => {
        state.notMatchingID = action.payload?.data;
        return state;
      })
      .addCase(pdfIDMatchingAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(filterColumnAction.pending, (state, action) => {
        state.loading = false;
        return state;
      })
      .addCase(filterColumnAction.fulfilled, (state, { payload }) => {
        let trueCount = 0;
        const filter = payload ?? {};
        // Object.fromEntries(
        //   Object.entries(payload).map(([key, value]) => {
        //     if (value === true && trueCount < 20) {
        //       trueCount++;
        //       return [key, true];
        //     }
        //     return [key, false];
        //   })
        // );
        const extractTrueKeys = (casefilter) => {
          if (casefilter && typeof casefilter === "object") {
            return [
              "#",
              ...Object.keys(casefilter).filter(
                (key) => casefilter[key] === true
              ),
            ];
          }
          return [];
        };
        state.caseFilter = filter;
        state.columnArrange = extractTrueKeys(filter);

        return state;
      })
      .addCase(filterColumnAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(dashboardCaseDetailsCountsAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        dashboardCaseDetailsCountsAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(dashboardCaseDetailsCountsAction.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(preTrailCaseDetailsCreateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        preTrailCaseDetailsCreateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(preTrailCaseDetailsCreateAction.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(preTrailCaseDetailsUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        preTrailCaseDetailsUpdateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(preTrailCaseDetailsUpdateAction.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(preTrailCaseDetailsDocumentsAction.pending, (state, action) => {
        state.loading = true;
        return state;
      })
      .addCase(
        preTrailCaseDetailsDocumentsAction.fulfilled,
        (state, { payload }) => {
          state.preTrailCaseDetailsDocuments = payload?.documents;
          state.loading = false;
          return state;
        }
      )
      .addCase(preTrailCaseDetailsDocumentsAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(preTrailCaseDetailsDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        preTrailCaseDetailsDeleteAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(preTrailCaseDetailsDeleteAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(claimantsListOfEvidenceCreateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantsListOfEvidenceCreateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        claimantsListOfEvidenceCreateAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(claimantsListOfEvidenceDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantsListOfEvidenceDeleteAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        claimantsListOfEvidenceDeleteAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(claimantsListOfEvidenceUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantsListOfEvidenceUpdateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        claimantsListOfEvidenceUpdateAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(
        respondentsListOfEvidenceCreateAction.pending,
        (state, action) => {
          return state;
        }
      )
      .addCase(
        respondentsListOfEvidenceCreateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        respondentsListOfEvidenceCreateAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(
        respondentsListOfEvidenceDeleteAction.pending,
        (state, action) => {
          return state;
        }
      )
      .addCase(
        respondentsListOfEvidenceDeleteAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        respondentsListOfEvidenceDeleteAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(
        respondentsListOfEvidenceUpdateAction.pending,
        (state, action) => {
          return state;
        }
      )
      .addCase(
        respondentsListOfEvidenceUpdateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        respondentsListOfEvidenceUpdateAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(claimantSideWitnessCreateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantSideWitnessCreateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(claimantSideWitnessCreateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(claimantSideWitnessUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantSideWitnessUpdateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(claimantSideWitnessUpdateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(claimantSideWitnessDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantSideWitnessDeleteAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(claimantSideWitnessDeleteAction.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(respondentWitnessCreateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        respondentWitnessCreateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(respondentWitnessCreateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(respondentWitnessUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        respondentWitnessUpdateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(respondentWitnessUpdateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(respondentWitnessDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        respondentWitnessDeleteAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(respondentWitnessDeleteAction.rejected, (state, action) => {
        state.error = action.payload;
      })

      .addCase(claimantSideArgumentsCreateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantSideArgumentsCreateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(claimantSideArgumentsCreateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(claimantSideArgumentsUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantSideArgumentsUpdateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(claimantSideArgumentsUpdateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(claimantSideArgumentsDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        claimantSideArgumentsDeleteAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(claimantSideArgumentsDeleteAction.rejected, (state, action) => {
        state.error = action.payload;
      })

      //

      .addCase(respondentSideArgumentsCreateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        respondentSideArgumentsCreateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        respondentSideArgumentsCreateAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(respondentSideArgumentsUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        respondentSideArgumentsUpdateAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        respondentSideArgumentsUpdateAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(respondentSideArgumentsDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(
        respondentSideArgumentsDeleteAction.fulfilled,
        (state, { payload }) => {
          return state;
        }
      )
      .addCase(
        respondentSideArgumentsDeleteAction.rejected,
        (state, action) => {
          state.error = action.payload;
        }
      )
      .addCase(dispositionsCreateAction.pending, (state, action) => {
        return state;
      })
      .addCase(dispositionsCreateAction.fulfilled, (state, { payload }) => {
        return state;
      })
      .addCase(dispositionsCreateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(dispositionsUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(dispositionsUpdateAction.fulfilled, (state, { payload }) => {
        return state;
      })
      .addCase(dispositionsUpdateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(dispositionsDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(dispositionsDeleteAction.fulfilled, (state, { payload }) => {
        return state;
      })
      .addCase(dispositionsDeleteAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(enforcementsCreateAction.pending, (state, action) => {
        return state;
      })
      .addCase(enforcementsCreateAction.fulfilled, (state, { payload }) => {
        return state;
      })
      .addCase(enforcementsCreateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(enforcementsUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(enforcementsUpdateAction.fulfilled, (state, { payload }) => {
        return state;
      })
      .addCase(enforcementsUpdateAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(enforcementsDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(enforcementsDeleteAction.fulfilled, (state, { payload }) => {
        return state;
      })
      .addCase(enforcementsDeleteAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(appealDeleteAction.pending, (state, action) => {
        return state;
      })
      .addCase(appealDeleteAction.fulfilled, (state, { payload }) => {
        return state;
      })
      .addCase(appealDeleteAction.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(caseDetailsBulkUpdateAction.pending, (state, action) => {
        return state;
      })
      .addCase(caseDetailsBulkUpdateAction.fulfilled, (state, { payload }) => {
        return state;
      })
      .addCase(caseDetailsBulkUpdateAction.rejected, (state, action) => {
        // state.error = action.payload;
      })

      .addCase(createClaimantCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createClaimantCounselAction.fulfilled, (state, action) => {
        state.loading = false;
        // state.data.push(action.payload);
      })
      .addCase(createClaimantCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(updateClaimantCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateClaimantCounselAction.fulfilled, (state, action) => {
        state.loading = false;
        const { counselIndex } = action.meta.arg;
        // state.data[counselIndex] = action.payload;
      })
      .addCase(updateClaimantCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteClaimantCounselAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteClaimantCounselAction.fulfilled, (state, action) => {
        const { counselIndex } = action.meta.arg;
        // state.data.splice(counselIndex, 1);
        state.loading = false;
      })
      .addCase(deleteClaimantCounselAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })


      .addCase(allOrganiationReportsAction.pending, (state) => {
        state.loading = true;

      })
      .addCase(allOrganiationReportsAction.fulfilled, (state, action) => {


        state.reports = action.payload ?? [];
        state.loading = false;
        return state;
      })
      .addCase(allOrganiationReportsAction.rejected, (state, action) => {
        state.loading = false;
      })


      .addCase(allOrganiationSingleReportsAction.pending, (state) => {
        state.loading = true;

      })
      .addCase(allOrganiationSingleReportsAction.fulfilled, (state, action) => {


        state.exportReport = action.payload?.orderedResult ?? [];
        state.selectedReport = action.payload?.orgReport ?? [];
        state.loading = false;
        return state;
      })
      .addCase(allOrganiationSingleReportsAction.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(caseDetailsTemplateBulkUpdateAction.pending, (state) => {
        state.loadingProgress = true;
        state.error = null;
        state.progress = 0;
      })
      .addCase(caseDetailsTemplateBulkUpdateAction.fulfilled, (state, action) => {
        state.loadingProgress = false;
        state.results = action.payload.results || [];
        state.progress = 100;
        state.error = null;
      })
      .addCase(caseDetailsTemplateBulkUpdateAction.rejected, (state, action) => {
        state.loadingProgress = false;
        state.error = action.payload || "Bulk update failed — please try again.";
        state.progress = 0;
      })
      .addCase(getOrganizationBatchNoAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOrganizationBatchNoAction.fulfilled, (state, action) => {
        state.loading = false;
        state.organizationBatchNo = action.payload;
      })
      .addCase(getOrganizationBatchNoAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
});

export const {
  resetMappingDetailsReducer,
  resetMappingAllDetailsReducer,
  allotmentHeaderReducer,
  mappingTemplateReducer,
  resetSingleCaseDetailsReducer,
  bulkCaseUpdateReducer,
  resetOrgCaseTypeReportReducer,
  setPaginationReducer,
  resetPaginationReducer,
  setPaginationSize,
  setProgress,
  setCaseTableFiltersReducer,
  resetCaseTableFiltersReducer,
} = caseSlice.actions;
export default caseSlice.reducer;
